import {Poi} from '../../react-app-env';
import React from 'react';
import ListViewGroup from '../listview/listviewgroup/ListViewGroup';
import {i18n} from '../../i18n/i18n';
import ListViewItem from '../listview/listviewitem/ListViewItem';
import {noop} from '../../utils/Utils';
import {PoiMetaData} from '../../services/MetaDataService';
import {DefaultItemDecorations} from '../listview/listviewitem/ListViewItem.types';

export interface DescriptionGroupProps {
  poi: Poi;
  metaData: PoiMetaData | null;
}

const DescriptionGroup: React.FunctionComponent<DescriptionGroupProps> = ({ poi, metaData }) => {

  const description = poi.description ?? metaData?.description;
  const editDescriptionLabel = poi.description
      ? i18n().poiDetails.description.editDescription
      : i18n().poiDetails.description.addDescription

  return <ListViewGroup>
    {!!description && (
        <ListViewItem title={description}/>
    )}
    <ListViewItem title={editDescriptionLabel}
                  iconCategory="fa-comment fa-regular"
                  decoration={DefaultItemDecorations.EDIT}
                  onClick={() => noop()}/>
  </ListViewGroup>;
};

export default DescriptionGroup;
